import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionLostService {
  private _isVisible$ = new BehaviorSubject<boolean>(false);

  get isVisible$() {
    return this._isVisible$.asObservable();
  }

  get isVisible(): boolean {
    return this._isVisible$.value;
  }

  show() {
    this._isVisible$.next(true);
  }

  hide() {
    this._isVisible$.next(false);
  }
}